import $ from 'jquery';

export class SlidersPaging {
    constructor(controller, targetSliders) {
        // A controller, in this case, is the term used for something that controls the slides.
        // In the instance of this site, it's the tabbs above the tracks, for example
        const tabs = controller.querySelectorAll('a');
        const indicator = controller.querySelector('.active-indicator');
            
        // One controller can control multiple slideshows. 
        targetSliders.forEach(slide => {
            const startPos = $(tabs[0]).position().left;
            // Set the indicator to the first slide position
            // Ideally this would be removed an replaced by a function, but time was up
            indicator.style.transform = `translateX(${startPos + ($(tabs[0]).width() * 0.5)}px)`;

            // eslint-disable-next-line max-params
            $(slide).on('beforeChange', function(jquery, slider, currentSlide, nextSlide) {
                const activePageButton = $(tabs[nextSlide]);
                const activePageButtonPosition = activePageButton.position();

                $(tabs).removeClass('is-active');
                activePageButton.addClass('is-active');

                // If there are more tabs than there is space, the element is scrollable
                // scroll to the clicked tab position with an animation
                controller.scrollTo({
                    left: activePageButtonPosition.left - startPos,
                    behavior: 'smooth'
                });
                const indicatorPosition = activePageButtonPosition.left + (activePageButton.width() * 0.5);
                indicator.style.transform = `translateX(${indicatorPosition}px)`;
            });
        });
        // On click, change slider
        tabs.forEach((button, index) => {
            button.addEventListener('click', (e) => {
                e.preventDefault();
                targetSliders.forEach(slide => {
                    $(slide).slick('slickGoTo', index);
                });
            });
        });
    }
}